import { render, staticRenderFns } from "./MatrixTableSettings.vue?vue&type=template&id=b6263b0c"
import script from "./MatrixTableSettings.vue?vue&type=script&lang=js"
export * from "./MatrixTableSettings.vue?vue&type=script&lang=js"
import style0 from "./MatrixTableSettings.vue?vue&type=style&index=0&id=b6263b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports